// @flow

const botSettingsContentStyles = {
  tableContainer: (theme) => ({
    flexGrow: 1,
    width: '100%',
    padding: theme.spacing(3), // Desktop padding: 24px all around
    [theme.breakpoints.down('sm')]: {
      minWidth: 0,
      padding: 0  // Mobile: NO padding (ContentContainer handles spacing)
      // paddingTop is now handled by ContentContainer wrapper
    }
  }),

  tableContent: (theme) => ({
    // old "className={classes.tableContent}" => use an sx with this key
  }),

  toolbar: (theme) => ({
    // old "className={classes.toolbar}"
  }),

  tabsCtr: (theme) => ({
    borderRadius: 0,
    maxWidth: 700
  }),

  cardCtr: (theme) => ({
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    maxWidth: 600,
    borderRadius: 0
  }),

  textFieldCtr: (theme) => ({
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    border: `2px solid ${theme.palette.primary.lighter}`
  }),

  textField: (theme) => ({
    marginTop: theme.spacing(1)
  }),

  stepTitle: (theme) => ({
    marginBottom: theme.spacing(1)
  }),

  chip: (theme) => ({
    marginRight: theme.spacing(0.5)
  }),

  submitBtn: (theme) => ({
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2)
  }),

  tabBody: (theme) => ({
    minHeight: 600
  }),

  boxRoot: (theme) => ({
    padding: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1)
    }
  }),

  tabBar: (theme) => ({
    padding: `${theme.spacing(0.5)} ${theme.spacing(3)}`
  }),

  keywordRow: (theme) => ({
    position: 'relative',
    maxWidth: 800,
    minWidth: 500,
    height: 50,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    marginBottom: '2px',
    marginTop: '2px',
    [theme.breakpoints.down('sm')]: {
      minWidth: 0
    }
  }),

  keywordRowOFF: (theme) => ({
    opacity: '40%'
  }),

  appBar: (theme) => ({
    backgroundColor: theme.palette.background.paper
  }),

  colKeywordContent: (theme) => ({
    paddingTop: theme.spacing(0.5),
    fontWeight: 700,
    fontSize: '1rem',
    [theme.breakpoints.down('sm')]: {
      overflow: 'scroll',
      display: 'flex',
      flexWrap: 'nowrap'
    }
  }),

  colMsgIcon: (theme) => ({
    paddingTop: theme.spacing(1),
    width: 50
  }),

  colKeyword: (theme) => ({
    paddingTop: theme.spacing(1),
    width: 300,
    flexGrow: 1
  }),

  colTimestamp: (theme) => ({
    paddingTop: theme.spacing(2),
    width: 200,
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  }),

  colSwitch: (theme) => ({
    width: 60,
    marginTop: theme.spacing(0.5) + 1,
    marginRight: theme.spacing(1)
  }),

  colEditIcon: (theme) => ({
    paddingTop: 1,
    width: 50,
    textAlign: 'right',
    paddingRight: theme.spacing(2)
  }),

  betaBadge: (theme) => ({
    fontWeight: 700,
    color: theme.palette.custom.neoViolet?.main,
    backgroundColor: theme.palette.custom.neoYellow?.main,
    transform: 'translate(50%, -55%) scale(0.8)'
  }),

  taskLogItemUser: (theme) => ({
    fontWeight: 600,
    marginTop: theme.spacing(0.5) + 1,
    marginRight: theme.spacing(0.5)
  })
};

export default botSettingsContentStyles;